import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchDefualtKeyTermsThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchDefaultKeyTerms`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getDefualtKeyTerms();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch default key terms. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
